import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["$spaceCssStyles"],
  _excluded2 = ["className"];
import styled from 'styled-components';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { jsx as _jsx } from "react/jsx-runtime";
export function createTokenizedComponent(Component) {
  const StyledComponent = styled(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _ref => {
    let props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props));
  })(({
    $spaceCssStyles
  }) => {
    return Object.assign({}, $spaceCssStyles);
  });
  return function TokenizedComponent(props) {
    const {
      tokenProps,
      restProps
    } = filterTokenProps(props);
    const spaceCssStyles = useMapTokenPropsToCSS(tokenProps);
    return /*#__PURE__*/_jsx(StyledComponent, Object.assign({}, restProps, {
      $spaceCssStyles: spaceCssStyles
    }));
  };
}
export function withoutClassName(props) {
  const rest = _objectWithoutPropertiesLoose(props, _excluded2);
  return rest;
}